import React from 'react';
import { Link } from 'react-router-dom';
export function FiretreeLogo({
  className = ''
}: {
  className?: string;
}) {
  return <Link to="/" className={`flex items-center group ${className}`} aria-label="Firetree Home" data-id="element-77">
      <img src="https://cdn.magicpatterns.com/uploads/5vbS7yVqrfbNikFDrhiAgc/logo-fund.png" alt="Firetree Fund" className="h-12 w-auto group-hover:opacity-80 transition-opacity" data-id="element-78" />
    </Link>;
}